import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import SVG from "react-inlinesvg";

export type SortDirection = "none" | "asc" | "desc";

// 클릭할 때마다 정렬 방향을 순환: none → desc → asc → none.
export function cycleSortDirection(dir: SortDirection): SortDirection {
  if (dir === "none") return "desc";
  if (dir === "desc") return "asc";
  return "none";
}

interface SortableTableHeaderProps {
  label: string;
  direction: SortDirection;
  onClick: () => void;
  textAlign?: "left" | "right";
}

// AppTable 헤더 셀에 ReactNode로 넣어 쓰는 정렬 토글 헤더.
// AppTable 자체는 단순 렌더러라 정렬 상태는 패널이 관리한다.
export default function SortableTableHeader({
  label,
  direction,
  onClick,
  textAlign = "right",
}: SortableTableHeaderProps) {
  return (
    <Flex
      as={"button"}
      type={"button"}
      width={"100%"}
      alignItems={"center"}
      justifyContent={textAlign === "right" ? "flex-end" : "flex-start"}
      gap={"2px"}
      cursor={"pointer"}
      userSelect={"none"}
      fontWeight={"700"}
      color={direction === "none" ? undefined : "#1272EF"}
      _hover={{ color: "#1272EF" }}
      onClick={onClick}
      aria-sort={
        direction === "asc"
          ? "ascending"
          : direction === "desc"
          ? "descending"
          : "none"
      }
    >
      <Text>{label}</Text>
      {direction !== "none" && (
        <Box
          display={"flex"}
          transform={direction === "asc" ? "rotate(180deg)" : "rotate(0deg)"}
          transition={"transform 0.15s"}
        >
          <SVG src={"/icons-v1_1/chevron-down.svg"} width={"12"} height={"12"} />
        </Box>
      )}
    </Flex>
  );
}